import { bool, node, number } from "prop-types";
import { forwardRef, useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";
import { opacity } from "theme";

const OpacityRelay = styled("div")`
  ${opacity}
`;

const FnrOpacityToggle = forwardRef(
  /**
   * A container used to toggle from visible to not visible without changing the dom layout. Also disables click action when not visible.
   * @param {object} param0
   * @param {boolean} param0.show - should the contained element be shown?
   * @param {boolean} param0.scale - scales the content as it fades.
   * @param {number} param0.delayIn - delays fading in (ms)
   * @returns
   */
  ({ show, children, scale, delayIn, ...rest }, ref) => {
    const [showTimeout, setShowTimeout] = useState(!delayIn);
    const timeoutRef = useRef();

    useEffect(() => {
      if (show) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => setShowTimeout(true), delayIn);
      }
      return () => clearTimeout(timeoutRef.current);
    }, [delayIn, show]);

    useEffect(() => {
      if (!show && delayIn) setShowTimeout(false);
    }, [show, delayIn]);

    return (
      <OpacityRelay
        $variant={show && showTimeout ? "shown" : "hidden"}
        $scale={scale}
        ref={ref}
        {...rest}
      >
        {children}
      </OpacityRelay>
    );
  }
);

FnrOpacityToggle.propTypes = {
  show: bool,
  scale: bool,
  children: node,
  delayIn: number,
};

export default FnrOpacityToggle;
